import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import "./Notification.css";

const Notification = (props: any) => {
  const [exit, setExit] = useState(false);
  const [width, setWidth] = useState(0);
  const [intervalID, setIntervalID] = useState<any>(null);

  const handleStartTimer = () => {
    const id = setInterval(() => {
      setWidth((prev) => {
        if (prev < 300) {
          return prev + 0.5;
        }
        return prev;
      });
    }, 20);

    setIntervalID(id);

    return () => clearInterval(id);
  };

  const handlePauseTimer = () => {
    clearInterval(intervalID);
  };

  const handleCloseNotification = () => {
    handlePauseTimer();
    setExit(true);
    setTimeout(() => {
      props.dispatch({
        type: "REMOVE_NOTIFICATION",
        id: props.id,
      });
    }, 400);
  };

  React.useEffect(() => {
    if (width >= 300) {
      // Close notification
      handleCloseNotification();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);

  React.useEffect(() => {
    handleStartTimer();
  }, []);

  return (
    <div
      onMouseEnter={handlePauseTimer}
      onMouseLeave={handleStartTimer}
      className={`notification-item ${
        props.type === "SUCCESS" ? "success" : "error"
      } ${exit ? "exit" : ""}`}
    >
      <MdClose onClick={handleCloseNotification} className="cancel-icon" />
      <p>{props.message}</p>
      <div className={"bar"} style={{ width: `${width / 3}%` }} />
    </div>
  );
};

export default Notification;
